const transitions = {
  fast: 'all ease-in .15s',
  slower: 'all ease-in .3s',
};

export default transitions;
